import { adminHttpClient } from '../../commons/adminHttpClient'

export const saveCompanyUserNotificationAction = (notificationId: string): Promise<any> => {
    const data = { notificationId: notificationId }
    return adminHttpClient.post('/Notifications/Action', data)
}

export default saveCompanyUserNotificationAction